var app = angular.module('leonardo');

var PermissionService = function(AuthDataService) {
  var service = {
    authDataService: AuthDataService
  };

  service.permissionAvailable = function(permission, item) {
    // Prevent own user to edit / delete himself
    if (AuthDataService.isAdmin()) {
      return true;
    }
    if (AuthDataService.isWhiteLabelAdmin()) {
      var viewPermission = service.getViewPermission(permission);
      return service.permissionAvailableAdmin(viewPermission);
    }
    var available = false;
    if (angular.isArray(permission)) {
      angular.forEach(permission, function (permission_element) {
        if (service.permissionAvailable(permission_element, item)) {
          available = true;
        }
      });
      return available;
    }
    else if(AuthDataService.authData.accountUser) {
      var account = (AuthDataService.authData.accountUser.account && AuthDataService.authData.accountUser.account.id) ?
        AuthDataService.authData.accountUser.account.id : AuthDataService.authData.accountUser.account;
      if (item) {
        account = (item.account && item.account.id) ? item.account.id : item.account;
      }
      if (item && (AuthDataService.authData.accountUser.permissions || service.isOwner())) {
        angular.forEach(AuthDataService.authData.accountUser.permissions, function(permissions){
          if (permissions.account == account) {
            switch (permission) {
              case 'permission_delete_user':
              case 'permission_edit_user':
                available = service.isOwner(permissions) ||
                  (permissions[permission] && (AuthDataService.authData.accountUser.id != item.id));
                break;
              default:
                available = service.isOwner(permissions) || permissions[permission];
                break;
            }
          }
        });
      }
      else {
        available = service.isOwner() || AuthDataService.authData.accountUser[permission];
      }
    }
    return available;
  };

  service.isOwner = function (permisions) {
    var is_owner = null;
    if (permisions) {
      is_owner = permisions.is_owner;
    }
    else {
      is_owner = (AuthDataService.authData.accountUser ? AuthDataService.authData.accountUser.is_owner : null);
    }
    return is_owner || AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin();
  };

  service.isExternal = function () {
    var is_external = false;
    angular.forEach(AuthDataService.authData.accountUsers, function (accountUser){
      if (accountUser.role && !isNull(accountUser.role.base_type) &&
        (accountUser.role.base_type.toString() === AuthDataService.accountUserRoleService.BASE_TYPE_EXTERNAL_APPROVER)) {
        is_external = true;
      }
    });
    return is_external;
  };

  service.isOwnerByAccount = function (account) {
    var is_owner = false;
    if (isEmpty(account)) {
      return service.isOwner();
    }
    if (angular.isArray(account)){
      angular.forEach(account, function (value) {
        if (service.isOwner(AuthDataService.getAccountUser(value))){
          is_owner = true;
        }
      });
    }
    else {
      is_owner = service.isOwner(AuthDataService.getAccountUser(account));
    }
    return is_owner;
  };

  service.isAccountOwner = function (permisions) {
    if (AuthDataService.isAdmin()) {
      return false;
    }
    if (AuthDataService.isWhiteLabelAdmin()) {
      return false;
    }
    if (permisions) {
      return permisions.is_owner
    }
    return (AuthDataService.authData.accountUser ? AuthDataService.authData.accountUser.is_owner : null);
  };

  service.permissionAvailableAccount = function(permission, allManagers) {
    if (AuthDataService.isAdmin()) {
      return true;
    }
    var available = false;
    if (AuthDataService.isWhiteLabelAdmin()) {
      available = true;
      if (angular.isArray(permission)) {
        angular.forEach(permission, function (permission_element) {
          if (_.contains(service.permissionsAccount, permission_element) && !AuthDataService.authData.whiteLabel.default_account_permissions[permission_element]) {
            available = false;
          }
        });
      }
      else if (_.contains(service.permissionsAccount, permission) && (!AuthDataService.authData.whiteLabel || !AuthDataService.authData.whiteLabel.default_account_permissions[permission])) {        available = false;
      }
      return available;
    }
    else if (angular.isArray(permission)) {
      angular.forEach(permission, function (permission_element) {
        if (service.permissionAvailableAccount(permission_element, allManagers)) {
          available = true;
        }
      });
      return available;
    }
    else if (AuthDataService.authData.accountsManager && AuthDataService.authData.accountUser) {
      var account = null;
      if (allManagers) {
        angular.forEach(AuthDataService.authData.accountsManager, function (manager) {
          if (manager.permissions) {
            if (AuthDataService.authData.whiteLabel) {
              if (AuthDataService.authData.whiteLabel.default_account_permissions[permission] && manager.permissions[permission]) {
                available = true;
              }
            }
            else if (manager.permissions[permission]) {
              available = true;
            }
          }
        });
      }
      else {
        angular.forEach(AuthDataService.authData.accountsManager, function (manager) {
          var user_account_id = (AuthDataService.authData.accountUser.account && AuthDataService.authData.accountUser.account.id) ?
            AuthDataService.authData.accountUser.account.id : AuthDataService.authData.accountUser.account;
          if (manager.id == user_account_id) {
            account = manager;
          }
        });
        if (account && account.permissions) {
          if (AuthDataService.authData.whiteLabel) {
            if (AuthDataService.authData.whiteLabel.default_account_permissions[permission] && account.permissions[permission]) {
              available = true;
            }
          }
          else if (account.permissions[permission]) {
            available = true;
          }
        }
      }
    }
    return available;
  };

  service.permissionAvailableAdmin = function(permission) {
    if (angular.isArray(permission)) {
      var available = true;
      angular.forEach(permission, function (permission_element) {
        if (!service.permissionAvailableAdmin(permission_element)){
          available = false;
        }
      });
      return available;
    }
    else {
      if (AuthDataService.isWhiteLabelAdmin()) {
        if (AuthDataService.authData.whiteLabel) {
          return (!isNull(AuthDataService.authData.whiteLabel.admin_permissions[permission]) ? AuthDataService.authData.whiteLabel.admin_permissions[permission] : true);
        }
        return true;
      }
      else {
        return AuthDataService.isAdmin();
      }
    }
  };

  service.getAccountByPermission = function(permission) {
    var accounts = [];
    if (angular.isArray(permission)) {
      angular.forEach(permission, function (permission_element) {
        accounts = accounts.concat(service.getAccountByPermission(permission_element));
      });
    }
    else {
      if(AuthDataService.authData.accountsManager && AuthDataService.authData.accountUser) {
        angular.forEach(AuthDataService.authData.accountsManager, function (manager) {
          if (manager.permissions && manager.permissions[permission]) {
            accounts.push(manager.id);
          }
        });
      }
      if (AuthDataService.authData.accountUsers.length > 1) {
        angular.forEach(AuthDataService.authData.accountUsers, function (manager) {
          if (manager[permission] && !accounts.includes(manager.account)) {
            accounts.push(manager.account);
          }
        });
      }
    }
    return accounts.filter(function(v,i) { return accounts.indexOf(v) === i });
  };

  service.getViewPermission = function(permission) {
    if (angular.isArray(permission)){
      var permissions = [];
      angular.forEach(permission, function (permission_element) {
        permissions.push(service.getViewPermission(permission_element));
      });
    }
    else {
      var group = permission.split('permission_')[1];
      var group_array = group.split('_');
      group_array.shift();
      return 'permission_view_' + group_array.join('_') + 's';
    }
  };

  service.getPermissionByView = function (view, level) {
    let permissionLevel = level || 'user';
    return service.permissionsByRoute[view] ? service.permissionsByRoute[view][permissionLevel] : [];
  };

  service.checkViewPermissions = function (view) {
    let available = true;
    if (AuthDataService.authData.accountUser) {
      if (!AuthDataService.isNotStaff()) {
        const permissionAdmin = service.getPermissionByView(view, 'admin');
        if (angular.isFunction(permissionAdmin)){
          available = permissionAdmin();
        }
        else {
          available = !isEmpty(permissionAdmin) ? service.permissionAvailableAdmin(permissionAdmin) : true;
        }
      }
      else {
        const permissionAccount = service.getPermissionByView(view, 'account');
        const permissionUser = service.getPermissionByView(view, 'user');
        let availableAccount;
        if (angular.isFunction(permissionAccount)){
          availableAccount = permissionAccount();
        }
        else {
          availableAccount = !isEmpty(permissionAccount) ? service.permissionAvailableAccount(permissionAccount, true) : true;
        }
        let availableUser;
        if (angular.isFunction(permissionUser)){
          availableUser = permissionUser();
        }
        else {
          availableUser = !isEmpty(permissionUser) ? service.permissionAvailable(permissionUser) : true;
        }
        available = availableAccount && availableUser;
      }
    }
    return available;
  }

  service.permissionViewAvailable = function (view) {
    let available = true;
    let modified = false;
    if (service.isExternal()) {
      available = service.viewsExternal.includes(view);
      return available ? service.checkViewPermissions(view) : available;
    }
    const viewArray = view.split('.');
    if (viewArray.length > 1) {
      viewArray.pop();
      available = service.permissionViewAvailable(viewArray.join('.'));
    }
    if (!available) {
      return available;
    }
    if (service.viewsOnlyAdmin.includes(view)) {
      available = AuthDataService.isAdmin();
      modified = true;
    }
    if (service.viewsOnlyWLAdmin.includes(view)) {
      if (available && modified) {
        return service.checkViewPermissions(view);
      }
      available = AuthDataService.isWhiteLabelAdmin();
      modified = true;
    }
    if (service.viewsOnlyOwner.includes(view)) {
      if (available && modified) {
        return service.checkViewPermissions(view);
      }
      available = service.isOwner();
      modified = true;
    }
    if (service.viewsOnlyNotStaff.includes(view)) {
      if (available && modified) {
        return service.checkViewPermissions(view);
      }
      available = AuthDataService.isNotStaff();
    }
    if (available) {
      available = service.checkViewPermissions(view);
    }

    return available;
  }

  service.permissionsAdmin = [
    'permission_view_work_orders',
    'permission_view_templates',
    'permission_view_dynamic_forms',
    // 'permission_view_documents_setup',
    'permission_view_reports',
    'permission_view_on_demand_instructions',
    'permission_view_utilities',
  ];

  service.permissionsAccount = [
    'permission_view_dashboard',
    'permission_view_work_order',
    'permission_view_make_ready_board',
    'permission_resident_inspection',
    'permission_view_unit_workflows',
    'permission_view_workflows',
    'permission_view_property_groups',
    'permission_view_units',
    'permission_view_templates',
    'permission_view_templates_calendar',
    'permission_view_trigger_templates',
    'permission_view_code_templates_tasks',
    'permission_define_approval_steps',
    'permission_view_dynamic_forms',
    'permission_view_contacts',
    'permission_view_documents',
    'permission_view_documents_setup',
    'permission_view_reports',
    'permission_view_reports_mimo',
    'permission_view_on_demand_instructions',
    'permission_upload_sftp',
    'permission_live_chat',
    // 'permission_view_help_section',
    'permission_mobile_photo_annotation',
    'permission_login_with_sso',
    'permission_sso_get_properties_from_idp',
    'permission_sso_get_role_from_idp',
  ];

  service.permissions = [
    'permission_add_portfolio',
    'permission_edit_portfolio',
    'permission_delete_portfolio',
    'permission_add_property',
    'permission_edit_property',
    'permission_delete_property',
    'permission_add_property_group',
    'permission_edit_property_group',
    'permission_delete_property_group',
    'permission_add_vendor',
    'permission_edit_vendor',
    'permission_delete_vendor',
    'permission_add_user',
    'permission_edit_user',
    'permission_delete_user',
    'permission_add_template',
    'permission_edit_template',
    'permission_delete_template',
    'permission_deactivate_template',
    'permission_define_approval_steps',
    'permission_add_workflow',
    'permission_edit_workflow',
    'permission_delete_workflow',
    'permission_activate_workflow',
    'permission_add_dynamic_form',
    'permission_edit_dynamic_form',
    'permission_delete_dynamic_form',
    'permission_add_on_demand_instruction',
    'permission_edit_on_demand_instruction',
    'permission_delete_on_demand_instruction',
    'permission_add_on_demand_category',
    'permission_edit_on_demand_category',
    'permission_delete_on_demand_category',
    'permission_view_contact',
    'permission_add_contact',
    'permission_edit_contact',
    'permission_delete_contact',
    'permission_add_document',
    'permission_delete_document',
    'permission_edit_document',
    'permission_add_unit',
    'permission_edit_unit',
    'permission_delete_unit',
    'permission_add_work_order',
    'permission_view_work_order',
    'permission_edit_work_order',
    'permission_delete_work_order',
    'permission_complete_work_order',
    'permission_add_move_in_date',
    'permission_edit_move_in_date',
    'permission_change_task_date',
    'permission_delete_task',
    'permission_manage_envoy_tasks',
    'permission_manage_envoy_settings',
    'permission_view_thoughtspot_reporting',
    'permission_admin_turn',
    'permission_view_turn',
    'permission_edit_turn',
  ];

  service.viewsOnlyAdmin = [
    'white-labels',
    'admin',
    'admin-utilities',
    'integrations',
    'categories',
    'countries',
    'sectors',
    'property-deleted',
    'work-orders.custom-values',
    'templates.audit',
    'administrative-reports',
    'reports.admin-quick',
    // 'reports.user',
    // 'vendors.categories',
    // 'help',
    'users.add-admin',
  ];

  service.viewsOnlyWLAdmin = [
    'my-white-label',
    'admin',
    'admin-utilities',
    'property-deleted',
    'reports.admin-quick',
    // 'reports.user',
    // 'vendors.categories',
    'users.add-admin',
  ];

  service.viewsOnlyOwner = [
    'work-orders.custom-values',
    'portfolios.groups',
    'portfolios.unitsTypes',
    'users.roles',
    'documents.account',
    'documents.portfolio',
    'documents.property',
  ];

  service.viewsOnlyNotStaff = [
    'dashboard',
    'dashboard.map',
    'dashboard.overview',
    'property',
    'work-orders.list',
    'unit-turn',
    'workflows',
    'portfolios',
    'templates.calendar',
    'templates.trigger',
    'templates.audit',
    'contacts.list',
    'reports.my-reports',
    // 'help',
    'approvals',
  ];

  service.viewsExternal = [
    'approvals',
    'property.tasks.approval',
    'logout',
    'login-redirection',
    'login-redirection-work-as',
    'user-manage-account',
  ];

  service.permissionsByRoute = {
    'admin-utilities': {
      admin: ['permission_view_utilities'],
      account: [],
      user: [],
    },
    'dashboard': {
      admin: [],
      account: ['permission_view_dashboard'],
      user: [],
    },
    'work-orders': {
      admin: ['permission_view_work_orders'],
      account: ['permission_view_work_order'],
      user: [
       'permission_view_work_order',
       'permission_add_work_order',
       'permission_edit_work_order',
       'permission_delete_work_order',
       'permission_complete_work_order'
      ],
    },
    'work-orders.custom-values': {
      admin: ['permission_view_work_orders'],
      account: ['permission_view_work_order'],
      user: () => service.isOwnerByAccount(service.getAccountByPermission('permission_view_work_order'))
    },
    'work-orders.add': {
      admin: [],
      account: [],
      user: ['permission_add_work_order']
    },
    'unit-turn': {
      admin: [],
      account: ['permission_view_unit_workflows'],
      user: [],
    },
    'unit-turn.workflows-launch': {
      admin: [],
      account: ['permission_view_unit_workflows'],
      user: ['permission_activate_workflow'],
    },
    'unit-turn.workflows': {
      admin: [],
      account: ['permission_view_unit_workflows'],
      user: [
        'permission_add_workflow',
        'permission_edit_workflow',
        'permission_delete_workflow'
      ],
    },
    'unit-turn.workflow-edit': {
      admin: [],
      account: ['permission_view_unit_workflows'],
      user: ['permission_edit_workflow'],
    },
    'unit-turn.make-ready': {
      admin: [],
      account: ['permission_view_make_ready_board'],
      user: [],
    },
    'workflows': {
      admin: [],
      account: ['permission_view_workflows'],
      user: [],
    },
    'workflows.workflows-launch': {
      admin: [],
      account: ['permission_view_unit_workflows'],
      user: ['permission_activate_workflow'],
    },
    'workflows.workflows': {
      admin: [],
      account: ['permission_view_unit_workflows'],
      user: [
        'permission_add_workflow',
        'permission_edit_workflow',
        'permission_delete_workflow'
      ],
    },
    'workflows.workflow-edit': {
      admin: [],
      account: ['permission_view_unit_workflows'],
      user: ['permission_edit_workflow'],
    },
    'templates': {
      admin: ['permission_view_templates'],
      account: [
        'permission_view_templates',
        'permission_view_templates_calendar',
        'permission_view_trigger_templates'
      ],
      user: [],
    },
    'templates.list': {
      admin: [],
      account: ['permission_view_templates'],
      user: [],
    },
    'templates.calendar': {
      admin: [],
      account: ['permission_view_templates_calendar'],
      user: [],
    },
    'templates.trigger': {
      admin: [],
      account: ['permission_view_trigger_templates'],
      user: [],
    },
    'users.add': {
      admin: [],
      account: [],
      user: ['permission_add_user'],
    },
    'documents.dynamic-forms-folder': {
      admin: ['permission_view_dynamic_forms'],
      account: ['permission_view_dynamic_forms'],
      user: [
        'permission_add_dynamic_form',
        'permission_edit_dynamic_form',
        'permission_delete_dynamic_form'
      ],
    },
    'reports': {
      admin: ['permission_view_reports'],
      account: ['permission_view_reports'],
      user: [],
    },
    'reports.template': {
      admin: ['permission_view_templates'],
      account: [],
      user: AuthDataService.isWorkAsUser(),
    },
    'reports.property': {
      admin: [],
      account: [],
      user: ['permission_add_portfolio'],
    },
    'on-demand-instructions': {
      admin: ['permission_view_on_demand_instructions'],
      account: ['permission_view_on_demand_instructions'],
      user: [],
    },
    'on-demand-instructions.category-add': {
      admin: [],
      account: [],
      user: ['permission_add_on_demand_category'],
    },
    'on-demand-instructions.subcategory-add': {
      admin: [],
      account: [],
      user: ['permission_add_on_demand_category'],
    },
    'on-demand-instructions.instruction-add': {
      admin: [],
      account: [],
      user: ['permission_add_on_demand_instruction'],
    },
    'portfolios.groups': {
      admin: [],
      account: ['permission_view_property_groups'],
      user: [],
    },
    'portfolios.units': {
      admin: [],
      account: ['permission_view_units'],
      user: [],
    },
    'portfolios.unitsTypes': {
      admin: [],
      account: ['permission_view_units'],
      user: [],
    },
    'portfolios.property-edit': {
      admin: [],
      account: [],
      user: ['permission_edit_property', 'permission_read_only_property'],
    },
    'contacts': {
      admin: [],
      account: ['permission_view_contacts'],
      user: [
        'permission_view_contact',
        'permission_add_contact',
        'permission_edit_contact',
        'permission_delete_contact'
      ],
    },
    
    'documents.list': {
      admin: [],
      account: ['permission_view_documents'],
      user: [],
    },
    'documents.account': {
      admin: [],
      account: ['permission_view_documents_setup'],
      user: [],
    },
    'documents.portfolio': {
      admin: [],
      account: ['permission_view_documents_setup'],
      user: [],
    },
    'documents.property': {
      admin: [],
      account: ['permission_view_documents_setup'],
      user: [],
    },
    // 'help': {
    //   admin: [],
    //   account: ['permission_view_help_section'],
    //   user: () => !AuthDataService.getClientInstance(),
    // },
    'approvals': {
      admin: [],
      account: ['permission_define_approval_steps'],
      user: ['permission_define_approval_steps'],
    },
    
    // 'vendors': {
    //   admin: [],
    //   account: [],
    //   user: [
    //     'permission_add_vendor',
    //     'permission_edit_vendor',
    //     'permission_delete_vendor'
    //   ],
    // },
    // 'vendors.edit': {
    //   admin: [],
    //   account: [],
    //   user: ['permission_edit_vendor'],
    // },
  };

  return service;
};

app.factory('PermissionService', ['AuthDataService', PermissionService]);
